<template>
<div ref="BirthEdit">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">编辑繁育</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="Birthlist.length > 1 ? Birthlist.length : ''" class="item">
        <el-button @click="submitData">提交数据</el-button>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="GoBackPets(false)">返回日宠物繁育</el-button>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in Birthlist" :key="index" :ref="'Birth'+index">
            <div class="TTL-form-submit-box-title">繁育-{{index+1}}</div>
            <el-form :inline="false">
                
                <el-form-item>
                    <label class="TTL-form-label">繁育宠物信息</label>
                    <div class="TTL-birth-main top20">
                        <div class="TTL-birth">
                            <div class="TTL-birth-info" @click="SelectPetInfos(index,2,item.girl_type)">
                                <div class="TTL-pet-image">
                                <el-image :src="item.boy_pet_thumb ? item.boy_pet_thumb : require('@/assets/icon/pet-upload-default.png')" fit="cover" class="TTL-image-box-middle"/>
                                </div>
                                <span class="TTL-birth-name">{{item.boy_pet_name ? item.boy_pet_name : '宠物粑粑'}}<h>{{item.boy_type_name ? '（'+item.boy_type_name+'）' : ''}}</h></span>  
                                <div class="manorwoman" @click.stop="closePet(index,2)" v-if="item.boy_pet_id > 0">
                                <el-image :src="require('@/assets/icon/close-blue.png')" />
                                </div>
                            </div>
                        </div>
                        <div class="TTL-birth compare"><div class="TTL-pet-image"><el-image :src="require('@/assets/icon/compare.png')" fit="cover"/></div></div>
                        <div class="TTL-birth">
                            <div class="TTL-birth-info" @click="SelectPetInfos(index,3,item.boy_type)">
                                <div class="TTL-pet-image">
                                <el-image :src="item.girl_pet_thumb ? item.girl_pet_thumb : require('@/assets/icon/pet-upload-default.png')" fit="cover" class="TTL-image-box-middle"/>
                                </div>
                                <span class="TTL-birth-name">{{item.girl_pet_name ? item.girl_pet_name : '宠物麻麻'}}<h>{{item.girl_type_name ? '（'+item.girl_type_name+'）' : ''}}</h></span>  
                                <div class="manorwoman" @click.stop="closePet(index,3)" v-if="item.girl_pet_id > 0">
                                <el-image :src="require('@/assets/icon/close-blue.png')" />
                                </div>
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">配中日</label>
                    <div class="TTL-datetime">
                    <el-date-picker v-model="item.loveday" type="date" value-format="YYYY-MM-DD" placeholder="请选择配种日期" @change="SaveDataToBrowser"/>
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">预产期</label>
                    <div class="TTL-select">
                    <el-select v-model="item.birthday" placeholder="请选择预产期"  clearable filterable @change="SaveDataToBrowser">
                    <el-option v-for="(item,index) in yuchanqilist" :key="index" :label="item.name" :value="item.id" />
                    </el-select>
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">生产提醒</label>
                    <div class="TTL-select">
                    <el-select v-model="item.remindday" placeholder="请选择生产提醒"  clearable filterable @change="SaveDataToBrowser">
                    <el-option v-for="(item,index) in noticelist" :key="index" :label="item.name" :value="item.id" />
                    </el-select>
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">提醒时间<i>*</i></label>
                    <div class="TTL-datetime">
                    <el-time-picker v-model="item.remindtime" placeholder="请选择提醒时间" format="HH:mm" value-format="HH:mm" @change="SaveDataToBrowser"/>
                    </div>
                </el-form-item>
                
            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import INTERFACE_MODEL_BIRTH from '@/Interface/Pets/Birth';
import INTERFACE_MODEL_PETS from '@/Interface/Pets/Schedule';
import INTERFACE_MODEL_BASE from '@/Interface/index';
export default {
    components:{},
    data() {
        return {
            type:'add',
            file:'',             //图片变量，占位符
            addlimit: 10,        //单次新增限制
            Birthlist:[       //日程信息列表
                {
                 id:'',boy_pet_id:'',boy_pet_name:'',boy_pet_thumb:'',boy_sex:'',boy_type:'',boy_type_name:'',
                 girl_pet_id:'',girl_pet_name:'',girl_pet_thumb:'',girl_sex:'',girl_type:'',girl_type_name:'',
                 loveday:'',birthday:'',expireday:'',remindday:'',remindtime:'',expire_remind_day:''
                }
            ],    
            yuchanqilist:[],
            noticelist:[
                {id:1,name:"提前1天"},
                {id:2,name:"提前3天"},
                {id:3,name:"提前7天"}
            ],

            petselectIndex:'', //繁育宠物选择序号
            petselectsex:1,    //选择宠物性别（1-公 2-母）
            pointref:'',

        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {

        /** 修改页面显示标签信息 **/
        ChangePageLabel() {
            
        },


        /** 页数初始化 **/
        OnloadMethod() {
            this.GetBirthdayLisit();     //获取预产期天数列表
            this.GetNoticeList();        //获取提醒日期类型列表
            this.ParseDataFromBrowser(); //解析之前填写的数据
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {

            //选择宠物完成后返回宠物信息组件
            if(data.pets && this.petselectsex==2) { //公信息
                var obj=this.Birthlist[this.petselectIndex];
                obj.boy_pet_id=data.pets.id;
                obj.boy_pet_name=data.pets.name;
                obj.boy_pet_thumb=data.pets.thumb;
                obj.boy_sex=data.pets.sex;
                obj.boy_type=data.pets.type;
                obj.boy_type_name=data.pets.pettype;
                this.SaveDataToBrowser(); //保存数据
                //定位锚点
                this.$refs[this.pointref][0].scrollIntoView({behavior:'smooth',block:'start'}); 
                return false;

            }else if(data.pets && this.petselectsex==3) { //母信息
                var obj=this.Birthlist[this.petselectIndex];
                obj.girl_pet_id=data.pets.id;
                obj.girl_pet_name=data.pets.name;
                obj.girl_pet_thumb=data.pets.thumb;
                obj.girl_sex=data.pets.sex;
                obj.girl_type=data.pets.type;
                obj.girl_type_name=data.pets.pettype;
                this.SaveDataToBrowser(); //保存数据
                //定位锚点
                this.$refs[this.pointref][0].scrollIntoView({behavior:'smooth',block:'start'}); 
                return false;

            }


            if(data.isask) {          //兄弟组件跳转至当前组件时进行询问操作
                this.$confirm.confirm('当前有数据正在执行编辑操作，是否要执行覆盖操作 ？','操作提示',{confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}).then(()=> {
                    this.GetBirthInfos(data.ids);
                }).catch(()=> {
                    
                });

            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                
            }else {
                this.GetBirthInfos(data.ids);
            }

        },


        /** 提交数据 **/
        submitData() {
            var checkresult=this.CheckDataBeforeSubmit();
            if(checkresult.error==1) {this.$notice({title:'提交数据提示',message:checkresult.message,type:'warning'});return false;}

            //调整提交数据
            var data=[];
            for(var i=0;i<this.Birthlist.length;i++) data.push(this.Birthlist[i]);
            data=JSON.stringify(data);
            var loadingobj=this.$refs.BirthEdit;
            this.$loading.openloading(loadingobj);  //加载等待动画

            INTERFACE_MODEL_BIRTH.EDIT_BIRTH({data:data}).then((res) => {
                this.$loading.closeloading(loadingobj);
                if(res.status > 0) return false;
                this.resetParam(); //重置当前数据
                this.$notice({title:'成功提示',message:'数据提交成功',type:'success'});
                this.GoBackPets(true);
            });
        },


        /** 数据提交前进行检测 **/
        CheckDataBeforeSubmit() {
            var result={error:0,message:''};
            if(this.Birthlist.length==0) {result={error:1,message:'请添加繁育信息'};return result;}

            //检测品种参数
            var obj;
            for(var i=0;i < this.Birthlist.length;i++) {
                obj=this.Birthlist[i];
                if(!obj.boy_pet_id || obj.boy_pet_id=='') {result={error:1,message:'第'+(i+1)+'个繁育信息请添加种公不能为空'};return result;}
                if(!obj.girl_pet_id || obj.girl_pet_id=='') {result={error:1,message:'第'+(i+1)+'个繁育信息请添加种母不能为空'};return result;}
                if(!obj.loveday || obj.loveday=='') {result={error:1,message:'第'+(i+1)+'个繁育信息请选择配种日'};return result;}
                if(!obj.birthday || obj.birthday=='') {result={error:1,message:'第'+(i+1)+'个繁育信息请选择预产期'};return result;}
                if(!obj.remindday || obj.remindday=='') {result={error:1,message:'第'+(i+1)+'个繁育信息请选择预产期提醒日'};return result;}
            }
            return result;
        },


        /** 选择宠物信息 **/
        SelectPetInfos(index,sex,type) {
            this.petselectIndex=index;   //设置
            this.petselectsex=sex;       //设置选择性别
            this.pointref='Birth'+index; //设置锚点
            var navinfo={name:'宠物信息管理',labelentry:'Pet',components:'Pet',isshow:false};
            var data={Method:''};

            //需要组件执行设置的参数
            data.paramsetting={sex:sex,type:type,p:1,rollpage:10,ischange:true};
            sex==2 ? data.paramsetting.iszhong=7 : data.paramsetting.iszhong=''; //如果性别为公时要选择种公
            //需要组件执行锁定的搜索项
            data.paramlock={sexlock:true,typelock:true};

            data.isselect=true;
            data.rollbackcomponent='EditBirth';
            data.rollbackname='编辑繁育';
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 取消已选择的宠物 **/
        closePet(index,sex) {

            var obj=this.Birthlist[index];
            if(sex==2) { //种公
                obj.boy_pet_id='';
                obj.boy_pet_name='';
                obj.boy_pet_thumb='';
                obj.boy_sex='';
                obj.boy_type='';
                obj.boy_type_name='';

            }else if(sex==3) { //种母
                obj.girl_pet_id='';
                obj.girl_pet_name='';
                obj.girl_pet_thumb='';
                obj.girl_sex='';
                obj.girl_type='';
                obj.girl_type_name='';

            }
        },


        /////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////
        //关联基础数据加载  

        /** 获取发育信息列表 **/
        GetBirthInfos(ids) {
            var loadingobj=this.$refs.BirthEdit;
            this.$loading.openloading(loadingobj);  //加载等待动画
            INTERFACE_MODEL_BIRTH.GET_BIRTH_INFOS({ids:ids}).then((res) => {
                this.$loading.closeloading(loadingobj);
                if(res.status > 0) return false;
                this.Birthlist=res.data;
                this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
            });
        },


        /** 获取预产期信息列表 **/
        GetBirthdayLisit() {
            INTERFACE_MODEL_BIRTH.GET_BIRTHDAY_LIST().then((res) => {
                if(res.status > 0) return false;
                this.yuchanqilist=res.data;
            });
        },

        /** 获取生产提醒日期列表 **/
        GetNoticeList() {
            INTERFACE_MODEL_BIRTH.GET_NOTICE_TYPE_LIST().then((res) => {
                if(res.status > 0) return false;
                this.noticelist=res.data;
            });
        },


        /** 重置加载数据 **/
        resetParam() {
            var data={
                 id:'',boy_pet_id:'',boy_pet_name:'',boy_pet_thumb:'',boy_sex:'',boy_type:'',boy_type_name:'',
                 girl_pet_id:'',girl_pet_name:'',girl_pet_thumb:'',girl_sex:'',girl_type:'',girl_type_name:'',
                 loveday:'',birthday:'',expireday:'',remindday:'',remindtime:'',expire_remind_day:''
                };
            this.Birthlist=[data];
        },


        /** 数据保存到浏览器 **/
        SaveDataToBrowser() {
            var data=JSON.stringify(this.Birthlist);
            localStorage.setItem('editBirthdata',data);
        },

        /** 从浏览器取数据解析 **/
        ParseDataFromBrowser() {
            var data=localStorage.getItem('editBirthdata');
            data ? data : data=[];
            
            !data || data=='' || data==[] ? 
            this.Birthlist=[{
                 id:'',boy_pet_id:'',boy_pet_name:'',boy_pet_thumb:'',boy_sex:'',boy_type:'',boy_type_name:'',
                 girl_pet_id:'',girl_pet_name:'',girl_pet_thumb:'',girl_sex:'',girl_type:'',girl_type_name:'',
                 loveday:'',birthday:'',expireday:'',remindday:'',remindtime:'',expire_remind_day:''
            }] : 
            this.Birthlist=JSON.parse(data);
        },

        /** 返回宠物管理组件 **/
        GoBackPets(isdellocal) {
            var navinfo={name:'繁育信息提醒',labelentry:'Birth',components:'Birth',isshow:false};
            var data={Method:''};
            if(isdellocal) data.delcomponents='EditBirth';
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },

    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:120px;height:120px;display: inline-block;border-radius: 5px;}
.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
.petTitle {padding:30px 0 20px 0;}
.TTL-remind-image {display:inline-block;width:70px;height: 70px;margin-left:20px;border-radius: 50%;}
.TTL-remind-image .el-image {border-radius: 50%;}
.TTL-birth-main {display:inline-flex;align-items: center;width:100%}
.TTL-birth {display:inline-block;}
.TTL-birth-info {width:120px;text-align: center;position:relative;}
.TTL-birth-info .TTL-image-box-middle {border-radius: 50%;}
.TTL-birth-name {font-size:13px;text-align: center;width:100%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
.compare {width:30px;height: 30px;margin:-40px 20px 0 20px;}
.TTL-birth-title {font-size:13px;color:#9c7d20;}
.manorwoman {width:20px;height: 20px;border-radius: 50%;position:absolute;top:0;right:0;background-color: #ffffff;padding:5px;cursor:pointer;}
</style>